import { useState, useEffect } from "react";
import { Form} from "react-bootstrap";
import authenticatedFetch from "./fetch"
import Select from "react-select"; 
import { getDocumentDisplayLabel } from "./linkedDocumentUtils";



const LinkedDocumentSelect = ({ entityType, providerId, handleDocumentChanged, selectedDocuments}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
      authenticatedFetch({
        path:  entityType + "/provider/" + providerId + "/files",
          successHandler: function(result) {
          setIsLoaded(true);
          setData(result);
        },
        errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
        }
    });
  }, [providerId])

  const options = data.map((document) => {
    let effectiveDateDisplay = "n/a";
    if (document.effectiveDate)
    {
      var parts = document.effectiveDate.split("-");
      const startDateObj = new Date(parts[0], parts[1] - 1, parts[2]);
      effectiveDateDisplay = new Date(startDateObj).toLocaleDateString("en-US");
    }

    let expirationDateDisplay = "n/a";
    if (document.expiration)
    {
      var parts = document.expiration.split("-");
      const endDateObj = new Date(parts[0], parts[1] - 1, parts[2]);
      expirationDateDisplay = new Date(endDateObj).toLocaleDateString("en-US");
    }

    return {value: document.filename, label: getDocumentDisplayLabel(document)};
  });

  if (!isLoaded)
  {
    return (<Form.Select size="sm" style={{width: "200px"}} disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
  }
  else if (error || !data)
  {
    return (<Form.Select size="sm" style={{width: "200px"}} disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
  }
  else
  {
      const customStyles = {
        control: (styles, state) => ({
            ...styles,
            minHeight: "calc(1.5em + 0.5rem + 2px)",
            fontSize: "0.8rem",
        }),
        valueContainer: (styles) => ({
            ...styles,
            padding: "0 6px",
        }),
        input: (styles) => ({
            ...styles,
            margin: 0,
            padding: 0,
        }),
        option: (styles) => ({
            ...styles,
            fontSize: "0.75rem",
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            padding: "0 4px",
        }),
        clearIndicator: (styles) => ({
            ...styles,
            padding: "0 4px",
        }),
      }

      return (
          <div style={{width: "200px", display: "inline-block"}}>
              <Select
              styles={customStyles}
              options={options}
              onChange={(selectedDocuments) => {
                handleDocumentChanged(selectedDocuments);
              }}
              value={selectedDocuments}
              placeholder="Select document(s)"
              isMulti
              theme={(theme) => ({
                ...theme,
                colors: {
                ...theme.colors,
                  primary50: '#DEF2F1',
                  primary25: '#DEF2F1',
                  primary: '#3AAFA9',
                },
              })}
              />
          </div>
      )
  }
}

export default LinkedDocumentSelect;
